import { render, staticRenderFns } from "./clientdashboard-set-password.vue?vue&type=template&id=338c8b2f&"
import script from "./clientdashboard-set-password.vue?vue&type=script&lang=js&"
export * from "./clientdashboard-set-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports